export default __webpack_public_path__ + "static/media/share.2536b502.svg";